import { render } from "./PieDePagina.vue?vue&type=template&id=c7c950b0&scoped=true"
import script from "./PieDePagina.vue?vue&type=script&lang=js"
export * from "./PieDePagina.vue?vue&type=script&lang=js"

import "./PieDePagina.vue?vue&type=style&index=0&id=c7c950b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c950b0"]])

export default __exports__